import styled from 'styled-components';
import { NumberInput } from 'ui-toolkit';

const CdNumberInput = styled(NumberInput)`
  input {
    text-align: end;
  }
`;

export default CdNumberInput;
